'use strict'

module.exports = url => ({
  type: 'GO',
  url,
})
